import { render, staticRenderFns } from "./UserCenterHeader.vue?vue&type=template&id=a50f7d92&scoped=true"
import script from "./UserCenterHeader.vue?vue&type=script&lang=js"
export * from "./UserCenterHeader.vue?vue&type=script&lang=js"
import style0 from "./UserCenterHeader.vue?vue&type=style&index=0&id=a50f7d92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50f7d92",
  null
  
)

export default component.exports